// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container--1XcZs0yy .ant-transfer-list-with-footer:first-child .ant-transfer-list-footer {\n      display: none;\n    }\n\n.footer--3Yd1lpHh {\n  text-align: right;\n  padding: 10px;\n  font-size: var(--normal-font-size);\n  font-weight: var(--font-weight-400);\n  color: var(--color-secondary-text);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "container--1XcZs0yy",
	"footer": "footer--3Yd1lpHh"
};
export default ___CSS_LOADER_EXPORT___;
